import { View } from "@react-pdf/renderer";
import {
  ResumePDFSection,
  ResumePDFDescription,
} from "components/Resume/ResumePDF/common";
import { styles } from "components/Resume/ResumePDF/styles";
import type { ResumeSkills } from "lib/redux/types";

export const ResumePDFSkills = ({
  heading,
  skills,
  themeColor,
  showBulletPoints,
  isSectionSelected,
  enableHighlight = false,
}: {
  heading: string;
  skills: ResumeSkills;
  themeColor: string;
  showBulletPoints: boolean;
  isSectionSelected?: boolean;
  enableHighlight?: boolean;
}) => {
  const { descriptions } = skills;
  return (
    <ResumePDFSection themeColor={themeColor} heading={heading} isSectionSelected={isSectionSelected}>
      <View style={{ ...styles.flexCol }} wrap={false}>
        <ResumePDFDescription 
          items={descriptions} 
          enableHighlight={enableHighlight}
          section="skills"
          itemIndex={null}
        />
      </View>
    </ResumePDFSection>
  );
};
